/* ==========================================================================
   AYRA — theme interactions
   Vanilla JS, no dependencies. Uses Shopify's AJAX Cart API.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var money = window.AyraTheme && window.AyraTheme.moneyFormat ? window.AyraTheme.moneyFormat : 'Rs.{{amount}}';
  var routes = (window.AyraTheme && window.AyraTheme.routes) || {};

  /* ---------- helpers ---------------------------------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return money.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  var scrollLocks = 0;
  function lockScroll(lock) {
    scrollLocks = Math.max(0, scrollLocks + (lock ? 1 : -1));
    document.body.classList.toggle('no-scroll', scrollLocks > 0);
  }

  /* ---------- toasts ----------------------------------------------------- */
  var toastHost;
  function toast(message, kind) {
    if (!toastHost) {
      toastHost = document.createElement('div');
      toastHost.className = 'toasts';
      toastHost.setAttribute('role', 'status');
      toastHost.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastHost);
    }
    var el = document.createElement('div');
    el.className = 'toast' + (kind === 'error' ? ' toast--error' : '');
    el.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
      (kind === 'error'
        ? '<path d="M8 4.5v4M8 11h.01M8 1.5 14.5 13h-13L8 1.5Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>'
        : '<path d="m3 8.5 3.2 3.2L13 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>') +
      '</svg><span></span>';
    $('span', el).textContent = message;
    toastHost.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () { el.remove(); }, 340);
    }, 3200);
  }
  window.ayraToast = toast;

  /* ---------- overlay controller ---------------------------------------- */
  var scrim = $('[data-scrim]');
  var openPanel = null;

  function closePanel() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    lockScroll(false);
    var trigger = openPanel.__trigger;
    if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
    openPanel = null;
  }

  function showPanel(panel, trigger) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) closePanel();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    panel.__trigger = trigger || null;
    if (scrim) scrim.classList.add('is-open');
    lockScroll(true);
    openPanel = panel;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var focusable = panel.querySelector('[data-autofocus]') || panel.querySelector('button, [href], input, select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }
  window.ayraOpenPanel = showPanel;
  window.ayraClosePanel = closePanel;

  on(scrim, 'click', closePanel);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      showPanel($('#' + opener.getAttribute('data-open')), opener);
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closePanel(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
    if (openPanel && e.key === 'Tab') {
      var items = $$('a[href], button:not([disabled]), input, select, textarea', openPanel)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- sticky header --------------------------------------------- */
  var header = $('[data-header]');
  if (header) {
    var lastY = 0;
    var tick = false;
    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      if (!openPanel) {
        header.classList.toggle('is-hidden', y > 320 && y > lastY);
      }
      lastY = y;
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();
  }

  /* ---------- mega menu (keyboard + touch support) ----------------------- */
  $$('[data-mega-trigger]').forEach(function (trigger) {
    var item = trigger.closest('.nav__item');
    var mega = item && $('.mega', item);
    if (!mega) return;
    on(trigger, 'click', function (e) {
      if (window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        var open = mega.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
    on(item, 'focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        mega.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ---------- mobile accordion nav --------------------------------------- */
  $$('[data-mnav-trigger]').forEach(function (btn) {
    on(btn, 'click', function () {
      var panel = btn.nextElementSibling;
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- announcement rotator --------------------------------------- */
  (function () {
    var slides = $$('[data-announce-slide]');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4200);
  })();

  /* ---------- hero slideshow --------------------------------------------- */
  $$('[data-hero-slides]').forEach(function (box) {
    var slides = $$('[data-hero-slide]', box);
    var dots = $$('[data-hero-dot]', box.closest('.hero') || box);
    if (slides.length < 2) return;
    var i = 0;
    var delay = parseInt(box.getAttribute('data-interval'), 10) || 6000;
    var timer;
    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function start() { timer = setInterval(function () { go(i + 1); }, delay); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (dot, n) {
      on(dot, 'click', function () { stop(); go(n); start(); });
    });
    on(box, 'mouseenter', stop);
    on(box, 'mouseleave', start);
    start();
  });

  /* ---------- scroll reveal ---------------------------------------------- */
  (function () {
    var nodes = $$('[data-reveal]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  })();

  /* ---------- quantity steppers ------------------------------------------ */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty]');
    if (!step) return;
    var box = step.closest('.qty');
    var input = $('input', box);
    var next = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart ------------------------------------------------------- */
  var cartDrawer = $('#cart-drawer');

  function renderShipBar() {
    var bar = $('[data-ship-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    var total = parseInt(bar.getAttribute('data-total'), 10) || 0;
    if (!threshold) return;
    var pct = Math.min(100, (total / threshold) * 100);
    var fill = $('[data-ship-fill]', bar);
    var text = $('[data-ship-text]', bar);
    if (fill) fill.style.width = pct + '%';
    if (text) {
      text.innerHTML = total >= threshold
        ? bar.getAttribute('data-done') || 'You have unlocked free shipping.'
        : (bar.getAttribute('data-away') || 'You are {{ amount }} away from free shipping.')
            .replace('{{ amount }}', '<b>' + formatMoney(threshold - total) + '</b>');
    }
  }
  renderShipBar();

  function refreshCart(openDrawer) {
    return fetch((routes.cart || '/cart') + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-content]');
        var current = $('[data-cart-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function (node) {
          if (!count) return;
          node.textContent = count.textContent;
          node.hidden = count.textContent.trim() === '0';
        });
        renderShipBar();
        if (openDrawer) showPanel(cartDrawer);
      })
      .catch(function () { toast('Could not refresh the bag. Please reload.', 'error'); });
  }

  function changeLine(key, quantity, node) {
    if (node) node.classList.add('is-loading');
    return fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(false); })
      .catch(function () { toast('Something went wrong.', 'error'); })
      .finally(function () { if (node) node.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-remove'), 0, remove.closest('.cart-line'));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10) || 1, input.closest('.cart-line'));
  });

  /* Add to cart — works for product forms and quick-add buttons */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="spinner"></span>'; }
    fetch((routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message);
        toast((res.data.product_title || 'Item') + ' added to your bag.');
        return refreshCart(true);
      })
      .catch(function (err) { toast(err.message || 'This item is unavailable.', 'error'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* ---------- predictive search ------------------------------------------ */
  (function () {
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    var defaults = $('[data-search-default]');
    if (!input || !results) return;
    var timer, controller;

    function recent(term) {
      try {
        var list = JSON.parse(localStorage.getItem('ayra:recent') || '[]');
        if (term) {
          list = [term].concat(list.filter(function (t) { return t !== term; })).slice(0, 5);
          localStorage.setItem('ayra:recent', JSON.stringify(list));
        }
        return list;
      } catch (err) { return []; }
    }

    (function paintRecent() {
      var host = $('[data-recent]');
      if (!host) return;
      var list = recent();
      if (!list.length) { host.hidden = true; return; }
      host.hidden = false;
      var box = $('[data-recent-list]', host) || host;
      box.innerHTML = list.map(function (t) {
        return '<a class="chip" href="' + (routes.search || '/search') + '?q=' + encodeURIComponent(t) + '">' + t + '</a>';
      }).join('');
    })();

    on(input, 'input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        results.innerHTML = '';
        if (defaults) defaults.hidden = false;
        return;
      }
      if (defaults) defaults.hidden = true;
      results.innerHTML = '<div class="sugg">' +
        '<div class="sugg__row"><div class="sugg__media skeleton"></div><div class="skeleton" style="height:14px"></div><span></span></div>'.repeat(3) +
        '</div>';
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = (routes.predictive || '/search/suggest') +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var box = doc.querySelector('[data-predictive]');
            results.innerHTML = box ? box.innerHTML : '<p class="meta">No matches found.</p>';
          })
          .catch(function (err) { if (err.name !== 'AbortError') results.innerHTML = '<p class="meta">Search is unavailable right now.</p>'; });
      }, 240);
    });

    var form = input.closest('form');
    on(form, 'submit', function () { recent(input.value.trim()); });
  })();

  /* ---------- wishlist (local, upgradeable to an app) -------------------- */
  (function () {
    var KEY = 'ayra:wishlist';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    function paint() {
      var list = read();
      $$('[data-wish]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-wish')) > -1 ? 'true' : 'false');
      });
      $$('[data-wish-count]').forEach(function (n) {
        n.textContent = list.length;
        n.hidden = list.length === 0;
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wish]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-wish');
      var list = read();
      var at = list.indexOf(id);
      if (at > -1) { list.splice(at, 1); toast('Removed from wishlist.'); }
      else { list.push(id); toast('Saved to wishlist.'); }
      write(list);
      paint();
    });
    paint();
  })();

  /* ---------- sticky mobile add-to-cart ---------------------------------- */
  (function () {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '-90px 0px 0px 0px' });
    io.observe(anchor);
  })();

  /* ---------- countdown --------------------------------------------------- */
  $$('[data-countdown]').forEach(function (box) {
    var end = new Date(box.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    var units = { d: $('[data-cd="d"]', box), h: $('[data-cd="h"]', box), m: $('[data-cd="m"]', box), s: $('[data-cd="s"]', box) };
    function pad(n) { return String(n).padStart(2, '0'); }
    function step() {
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      if (units.d) units.d.textContent = pad(Math.floor(s / 86400));
      if (units.h) units.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (units.m) units.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (units.s) units.s.textContent = pad(s % 60);
    }
    step();
    setInterval(step, 1000);
  });

  /* ---------- filter accordions ------------------------------------------ */
  $$('[data-filter-head]').forEach(function (btn) {
    on(btn, 'click', function () {
      var body = btn.nextElementSibling;
      var open = body.hidden;
      body.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- newsletter inline validation ------------------------------- */
  $$('[data-news-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      var input = $('input[type="email"]', form);
      if (!input) return;
      var ok = /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(input.value.trim());
      if (!ok) {
        e.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        var err = $('[data-news-error]', form);
        if (err) err.textContent = 'Please enter a valid email address.';
        input.focus();
      }
    });
    on($('input[type="email"]', form), 'input', function (e) {
      e.target.removeAttribute('aria-invalid');
      var err = $('[data-news-error]', form);
      if (err) err.textContent = '';
    });
  });
})();
